module.exports = __webpack_public_path__ + "img/4-2-4-2-0-preview-Super-Fans-e.0ab23607.jpg";